import { IBaseCounter } from '../BaseCounter/types'
import { CounterType } from '../CounterType';


export interface IVirtualCounter extends IBaseCounter {
    counts: CounterType;
}


export const schema = 'AutomationApps.Devices.Counters.VirtualCounter';



